export default "/assets/images/the-rookie-parent-crop.png?9304d368708700bf76ddd49a20055e41";